export default "__VITE_ASSET__MEUqAilQ__"